import { PubSub } from '@platform/api';
import { keyByModuleId } from '../WithKeyboardChange/createKeyMap';

/**
 * @desc 根据不同的formItem类型获取可聚焦的input元素
 * @types {
 *     1: refer,
 *     2: input, select, timepicker, dateTimePicker, datePicker, number,
 *     3: textarea
 * }
 * @matchItemFocus{
 *     refer: func
 * }
 */
let matchItemFocus = {
    refer: setReferItemFocus,
    input: setNormalItemFocus,
    textarea: setTextAreaFocus,
    select: setSelectItemFocus,
    switch: setSwitchItemFocus,
    switch_browse: setSwitchItemFocus,
    normal: setNormalItemFocus,
};
function setReferItemFocus(selector) {
    // let dom = ReactDOM.findDOMNode(component);
    let dom = selector && document.querySelector(selector);
    let inputEl = dom && dom.querySelector("input[tabindex='0']");
    let spanEl = dom && dom.querySelector("span[tabindex='0']");
    let wrapper = dom && dom.querySelector(".template-item-wrapper[tabindex='0']");
    if (wrapper) {
        //元素存在就让它聚焦
        wrapper.fromProgram = true;
        wrapper.focus();
        dom = null;
    } else if (inputEl) {
        //元素存在就让它聚焦
        inputEl.focus();
        dom = null;
    } else if (spanEl) {
        spanEl.focus();
        dom = null;
    } else {
        dom && dom.addEventListener(
            'DOMSubtreeModified',
            //autoFocusInTricky.bind(null, dom)
            function wrap(e) {
                autoFocusInTricky(dom, wrap, e);
            },
        );
    }
    // dom = null;
    inputEl = null;
    spanEl = null
}

/**
 * todo: 由于refer组件是异步加载，input获取焦点时无法得到dom元素，因此在这儿监听dom更改事件, 希望在refer内部触发一个告诉外部，组件一渲染完成
 */

function autoFocusInTricky(dom, fn, e) {
    let inputEl = e.target.querySelector("input[tabindex='0']");
    // inputEl = null
    if (inputEl) {
        setTimeout(() => {
            inputEl.focus();
            dom && dom.removeEventListener('DOMSubtreeModified', fn);
            inputEl = null;
            dom = null;
        });
    }
}

function setNormalItemFocus(selector) {
    // let dom = ReactDOM.findDOMNode(component);
    let dom = selector && document.querySelector(selector);
    let inputEl = dom && (dom.querySelector(".template-item-wrapper[tabindex='0']") || dom.querySelector('input'));

    inputEl && inputEl.focus();
    dom = null;
    inputEl = null;
}

function setTextAreaFocus(selector) {
    // let dom = ReactDOM.findDOMNode(component);
    let dom = selector && document.querySelector(selector);
    let textEl = dom && (dom.querySelector(".template-item-wrapper[tabindex='0']") || dom.querySelector('textarea'));

    textEl && textEl.focus();
    dom = null;
    textEl = null;
}

function setSelectItemFocus(selector) {
    // let dom = ReactDOM.findDOMNode(component);
    let dom = selector && document.querySelector(selector);
    let focusDom = dom && (dom.querySelector(".template-item-wrapper[tabindex='0']") || dom.querySelector('.u-select-selection[tabindex]') || dom.querySelector('input'));

    focusDom && focusDom.focus();
    dom = null;
    focusDom = null;
}

function setSwitchItemFocus(selector) {
    // let dom = ReactDOM.findDOMNode(component);
    let dom = selector && document.querySelector(selector);
    let switchEl = dom && (dom.querySelector(".template-item-wrapper[tabindex='0']") || dom.querySelector('span[tabindex]'));

    switchEl && switchEl.focus();
    dom = null;
    switchEl = null;
}

//标签切换时首个自动聚焦
function cellFocusAfterTabChange(item) {
    if (keyByModuleId[item]) {
        let focusItem = keyByModuleId[item].firstItem;

        let moduleId = keyByModuleId[item] && keyByModuleId[item]['parent']
            ? keyByModuleId[item]['parent']
            : item;
        focusItem && PubSub.publish('autoFocus', {
            data: focusItem,
            force: true,
            moduleId,
        });
    }

}

export default {
    matchItemFocus,
    cellFocusAfterTabChange,
};
